<template>
  <v-flex xs12>
    <v-title>Banking Details</v-title>
    <v-card>
      <v-layout row wrap class="ma-1">
        <v-flex xs6 class="px-1">
          <ValidationProvider v-slot="{ errors }" name="bank" rules="required">
            <v-text-field
              v-model="editableDealerManager.bank"
              label="Bank"
              :error-messages="errors"
              data-vv-name="bank"
              required
            ></v-text-field>
          </ValidationProvider>
        </v-flex>
        <v-flex xs6 class="px-1">
          <ValidationProvider
            v-slot="{ errors }"
            name="accountName"
            rules="required"
          >
            <v-text-field
              v-model="editableDealerManager.accountName"
              label="Account Name"
              :error-messages="errors"
              data-vv-name="accountName"
              required
            ></v-text-field>
          </ValidationProvider>
        </v-flex>
        <v-flex xs6 class="px-1">
          <ValidationProvider
            v-slot="{ errors }"
            name="accountNo"
            rules="required"
          >
            <v-text-field
              v-model="editableDealerManager.accountNo"
              label="Account No"
              :error-messages="errors"
              data-vv-name="accountNo"
              required
            ></v-text-field>
          </ValidationProvider>
        </v-flex>
        <v-flex xs6 class="px-1">
          <ValidationProvider v-slot="{ errors }" name="bsbno" rules="required">
            <v-text-field
              v-model="editableDealerManager.bsbno"
              label="BSB"
              :error-messages="errors"
              data-vv-name="bsbno"
              mask="###-###"
              required
              return-masked-value
            ></v-text-field>
          </ValidationProvider>
        </v-flex>
        <v-flex xs12 class="px-1">
          <ValidationProvider
            v-slot="{ errors }"
            name="branchAddress"
            rules="required"
          >
            <v-text-field
              v-model="editableDealerManager.branchAddress"
              label="Branch Address"
              :error-messages="errors"
              data-vv-name="branchAddress"
              required
            ></v-text-field>
          </ValidationProvider>
        </v-flex>
      </v-layout>
    </v-card>
  </v-flex>
</template>
<script>
export default {
  name: 'edit-banking-details',
  props: {
    dealerManager: {
      type: Object,
      required: true,
    },
  },
  computed: {
    editableDealerManager: {
      get() {
        return this.dealerManager;
      },
      set(val) {
        this.$emit('update:dealerManager', val);
      },
    },
  },
};
</script>
